import React, { useMemo } from 'react';
import { Typography } from 'antd';

import * as S from './Benefits.styles';

const { Text } = Typography;

interface Props {
    source?: string | null;
}

export const Benefits = ({ source }: Props) => {
    const benefits = useMemo(() => {
        if (!source) return [];
        try {
            const parsed = JSON.parse(source);
            if (Array.isArray(parsed)) {
                return parsed as { name: string }[];
            }
            return [];
        } catch {
            return [];
        }
    }, [source]);

    return (
        <S.List>
            {benefits.map((benefit, index) => (
                <S.ListItem key={index}>
                    <Text>{benefit.name}</Text>
                </S.ListItem>
            ))}
        </S.List>
    );
};
